export default "8122c839d7873561.png"